export { ErrorBoundary } from './ErrorBoundary';
export type {
  ErrorBoundaryProps,
  ErrorBoundaryState
} from './ErrorBoundary.types';
